import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TotalFMVRendererParams extends ICellRendererParams {
    activityStatusId: (params: TotalFMVRendererParams) => number;
    isFmvInclude: (params: TotalFMVRendererParams) => boolean;
    getTotal: (params: TotalFMVRendererParams) => string;
}


@Component({
    selector: 'total-fmv-renderer',
    template: `@if (activityStatusId === 0) {
  <img src="/images/inactive.jpg" alt="Inactive" class="table-inactive">
}
@if (activityStatusId === 1) {
  <img src="/images/active-pending.jpg" alt="Inactive" class="table-inactive">
}
@if (!isFmvInclude) {
  <span class="fa-stack" title="FMV excluded from site analysis">
    <i class="fa fa-stack-1x" style="font-weight: bold;">Σ</i>
    <i class="fa fa-ban fa-stack-2x text-danger fa-flip-horizontal"></i>
  </span>
}
{{total}}`,
    standalone: false
})
export class TotalFMVRendererComponent implements ICellRendererAngularComp {

    params: TotalFMVRendererParams;

    agInit(params: TotalFMVRendererParams): void {
        this.params = params;
    }

    get activityStatusId(): number {
        return this.params.activityStatusId(this.params);
    }

    get isFmvInclude(): boolean {
        return this.params.isFmvInclude(this.params);
    }

    get total(): string {
        return this.params.getTotal(this.params);
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
